import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../helpers/store/Store";
import {
  updateAdditionalTabs,
  updateDynaPropValues,
} from "../../helpers/actions/Action";

export class MetaPropertiesTableDynamic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dynaPropValueList: [],
    };
  }

  handleValueChange = (e) => {
    console.log("Guid ",this.props.guId)
    var dynaPropValuesStoretemp = this.props.dynaPropValuesStore;
    for (var i = 0; i < dynaPropValuesStoretemp.length; i++) {
      if (dynaPropValuesStoretemp[i].tag == this.props.tag) {
        for (
          var j = 0;
          j < dynaPropValuesStoretemp[i].propValueList.length;
          j++
        ) {
          if (
            dynaPropValuesStoretemp[i].propValueList[j].propName ==
            e.target.name
          ) {
            dynaPropValuesStoretemp[i].propValueList[j].propValue =
              e.target.value;
            break;
          }
        }

        this.setState({
          dynaPropValueList: dynaPropValuesStoretemp[i].propValueList,
        });

        break;
      }
    }

    store.dispatch(updateDynaPropValues(dynaPropValuesStoretemp));
  };

  componentDidMount() {
    // console.log(this.props.dynaPropValuesStore)
    this.props.dynaPropValuesStore.forEach((dynaPropValue, index) => {
      if (this.props.tag === dynaPropValue.tag) {
        this.setState({
          dynaPropValueList: dynaPropValue.propValueList,
        });
      }
    });
  }

  // componentDidUpdate(prevProps) {
  //     if(prevProps.dynaPropValuesStore !== this.props.dynaPropValuesStore){
  //         console.log("updating.........")
  //         this.props.dynaPropValuesStore.forEach((dynaPropValue, index)=>{
  //             if(this.props.tag===dynaPropValue.tag){
  //                 this.setState({
  //                     dynaPropValueList:dynaPropValue.propValueList
  //                 })
  //             }
  //         })
  //     }
  //   }

  componentDidUpdate() {
    this.saveTabData();
  }

  saveTabData = () => {
    var tabData = {
      ElemWithProps: JSON.stringify(this.props.elemWithProperties),
      Categories: JSON.stringify(this.props.categories),
      DynaPropValues: JSON.stringify(this.props.dynaPropValues),
      StatPropValues: JSON.stringify(this.props.statPropValues),
    };

    const tabSize =
      tabData.ElemWithProps.length +
      tabData.Categories.length +
      tabData.DynaPropValues.length +
      tabData.StatPropValues.length;

    // console.log("tabSize", tabSize);
    if (tabSize > 4700000) {
      store.dispatch(updateAdditionalTabs(false));
    } else {
      //redux state to change tab possible to true
      store.dispatch(updateAdditionalTabs(true));
      window.sessionStorage.setItem(
        this.props.selectedModel.fileName,
        JSON.stringify(tabData)
      );
    }
  };

  render() {
    return (
      <div>
        <table className="table table-sm table-responsive">
          <thead>
            <tr>
              <th>Property</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {this.state.dynaPropValueList.map((dynaProp, index) => {
              //Drop Downs
              var propName = dynaProp.propName;
              var propValue = dynaProp.propValue;
              console.log("dynaProp",dynaProp)
              console.log("dynaProp.Tag",dynaProp.tag)

              var dropDownNames = [
                "Operating Frequency",
                "Hazardous Area Specification",
                "P&ID Drawing Number",
                "Valve Type",
                "Regulation 31 Compliance Required",
                "Valve Top Fitting",
                "Valve Orientation",
                "Locking Facility",
              ];
              if (dropDownNames.includes(propName) && !this.props.locked) {
                if (propName === "Locking Facility") {
                  return (
                    <tr key={index}>
                      <td>{propName}</td>
                      <td>
                        <select
                          id={dynaProp.tag + "--" + propName}
                          value={propValue}
                          name={propName}
                          onChange={this.handleValueChange}>
                          <option value="">Please select an option</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                          <option value="Mechanical Interlock">
                            Mechanical Interlock
                          </option>
                        </select>
                      </td>
                    </tr>
                  );
                }

                if (propName === "Operating Frequency") {
                  return (
                    <tr key={index}>
                      <td>{propName}</td>
                      <td>
                        <select
                          id={dynaProp.tag + "--" + propName}
                          value={propValue}
                          name={propName}
                          onChange={this.handleValueChange}>
                          <option value="">Please select an option</option>
                          <option value=">10x Per Day">&gt;10x Per Day</option>
                          <option value="1-10x Per Day">1-10x Per Day</option>
                          <option value="1-30x Per Month">1-30x Per Month</option>
                          <option value="1-12x Per Year">1-12x Per Year</option>
                          <option value="Modulating">Modulating</option>
                        </select>
                      </td>
                    </tr>
                  );
                }
              }
              return (
                <tr key={index}>
                  <td>{dynaProp.propName}</td>
                  <td>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="text"
                        name={dynaProp.propName}
                        value={dynaProp.propValue}
                        autoComplete="off"
                        spellCheck="false"
                        placeholder={this.props.locked ? "" : "Enter Value"}
                        id="example-text-input"
                        onChange={this.handleValueChange}
                        disabled={this.props.locked}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dynaPropValuesStore: state.metaPropReducer.dynaPropValues,

  selectedModel: state.getSelectedModelReducer.data,
  elemWithProperties: state.metaPropReducer.elementWithProperties,
  categories: state.metaPropReducer.categories,
  dynaPropValues: state.metaPropReducer.dynaPropValues,
  statPropValues: state.metaPropReducer.statPropValues,
});

export default connect(mapStateToProps)(MetaPropertiesTableDynamic);
